import { EDITOR_TYPE } from '@wix/wix-data-client-common'
import {
  createCategoryItemFieldMap as itemFieldMapForClassic,
  createCategoryRouterFieldMap as routerFieldMapForClassic,
  createRepeaterNavMenuFieldMap as navMenuFieldMapForClassic,
} from './classic/categoryPresetFieldMap'
import {
  createCategoryItemFieldMap as itemFieldMapForStudio,
  createCategoryRouterFieldMap as routerFieldMapForStudio,
  createRepeaterNavMenuFieldMap as navMenuFieldMapForStudio,
} from './studio/categoryPresetFieldMap'
import type { Fields } from './types'

type CategoryRouterFieldMap = (params: {
  fields: Fields
}) => Record<string, string | undefined>
type CategoryItemFieldMap = (params: {
  fields: Fields
}) => Record<string, string | undefined>
type RepeaterNavMenuFieldMap = (params: {
  fields: Fields
  pageLinkFieldKey: string
}) => Record<string, string | undefined>

const routerFieldMapByEditorType: Partial<
  Record<EDITOR_TYPE, CategoryRouterFieldMap>
> = {
  [EDITOR_TYPE.CLASSIC]: routerFieldMapForClassic,
  [EDITOR_TYPE.STUDIO]: routerFieldMapForStudio,
}

const itemFieldMapByEditorType: Partial<
  Record<EDITOR_TYPE, CategoryItemFieldMap>
> = {
  [EDITOR_TYPE.CLASSIC]: itemFieldMapForClassic,
  [EDITOR_TYPE.STUDIO]: itemFieldMapForStudio,
}

const navMenuFieldMapByEditorType: Partial<
  Record<EDITOR_TYPE, RepeaterNavMenuFieldMap>
> = {
  [EDITOR_TYPE.CLASSIC]: navMenuFieldMapForClassic,
  [EDITOR_TYPE.STUDIO]: navMenuFieldMapForStudio,
}

export const createCategoryRouterFieldMap = ({
  editorType,
  fields,
}: {
  editorType: EDITOR_TYPE
  fields: Fields
}) => {
  const fieldMap =
    routerFieldMapByEditorType[editorType] ?? routerFieldMapForClassic
  return fieldMap({ fields })
}

export const createCategoryItemFieldMap = ({
  editorType,
  fields,
}: {
  editorType: EDITOR_TYPE
  fields: Fields
}) => {
  const fieldMap =
    itemFieldMapByEditorType[editorType] ?? itemFieldMapForClassic
  return fieldMap({ fields })
}

export const createRepeaterNavMenuFieldMap = ({
  editorType,
  fields,
  pageLinkFieldKey,
}: {
  editorType: EDITOR_TYPE
  fields: Fields
  pageLinkFieldKey: string
}) => {
  const fieldMap =
    navMenuFieldMapByEditorType[editorType] ?? navMenuFieldMapForClassic
  return fieldMap({ fields, pageLinkFieldKey })
}
